import { AxiosInstance } from 'axios'
import { Report } from './smilyTypes'
import { Report as DailyRatingReport } from './dailyRating'
import { AllRatingsReport } from './allRatings'

type FetchSmilyReportParams = Readonly<{
    startDate?: string
    endDate?: string
}>


export type FetchSmilyReportResponse = Readonly<{
    smilyReport: Report
}>


export async function fetchSmilyReportByPeriod({ startDate, endDate }: FetchSmilyReportParams, axios: AxiosInstance, signal?: AbortSignal): Promise<FetchSmilyReportResponse> {
    // TODO why are we using ID here?
    const url = `/surveys/:id/smileys/summary?from=${startDate}&to=${endDate}`


    const response = await axios.get(url, {
        params: {
            startDate,
            endDate
        },
        signal
    })

    return response.data
}





type FetchDailyRatingsReportParams = Readonly<{
    startDate?: string
    endDate?: string
}>


export type FetchDailyRatingsResponse = Readonly<{
    dailyReport: DailyRatingReport
}>


export async function fetchDailyRatingsReportByPeriod({ startDate, endDate }: FetchDailyRatingsReportParams, axios: AxiosInstance, signal?: AbortSignal): Promise<FetchDailyRatingsResponse> {
    // TODO why are we using ID here and I assume we need start and endDate here?
    const url = `/surveys/:id/ratings?from=${startDate}&to=${endDate}`


    const response = await axios.get(url, {
        params: {
            startDate,
            endDate
        },
        signal
    })

    return response.data
}



type FetchTopicSummaryReportParams = Readonly<{
    startDate?: string
    endDate?: string
}>


export type FetchTopicSummaryResponse = Readonly<{
    dailyReport: DailyRatingReport
}>


export async function fetchTopicSummaryReportByPeriod({ startDate, endDate }: FetchTopicSummaryReportParams, axios: AxiosInstance, signal?: AbortSignal): Promise<FetchTopicSummaryResponse> {
    // TODO why are we using ID here and I assume we need start and endDate here?
    const url = `/surveys/topics/summary?from=${startDate}&to=${endDate}`


    const response = await axios.get(url, {
        params: {
            startDate,
            endDate
        },
        signal
    })

    return response.data
}



type FetchAllRatingsReportParams = Readonly<{
    startDate?: string
    endDate?: string
}>

export type FetchAllRatingsResponse = Readonly<{
    allRatingReport: AllRatingsReport
}>

export async function fetchAllRatingsReportByPeriod({ startDate, endDate }: FetchAllRatingsReportParams, axios: AxiosInstance, signal?: AbortSignal): Promise<FetchAllRatingsResponse> {
    // TODO why are we using ID here and I assume we need start and endDate here?
    const url = `/surveys/:id/ratings?from=${startDate}&to=${endDate}`


    const response = await axios.get(url, {
        params: {
            startDate,
            endDate
        },
        signal
    })

    return response.data
}




